var PAProductCodes = ['PersonalAuto', 'personalAuto', 'auto_per'];

export default {
    normaliseProductCode: function normaliseProductCode(productCode) {
        if (PAProductCodes.includes(productCode)) {
            return 'PersonalAuto';
        }
        return productCode;
    },
    getLobSpecificKeyValue: function getLobSpecificKeyValue(key) {
        return key;
    }
};